import { render } from "./Prescription.vue?vue&type=template&id=2d0e3aec&scoped=true"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"

import "../shared/prescriptionCreate.css?vue&type=style&index=0&id=2d0e3aec&scoped=true&lang=css"
import "./Prescription.vue?vue&type=style&index=1&id=2d0e3aec&lang=css"
import "./Prescription.vue?vue&type=style&index=2&id=2d0e3aec&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0e3aec"]])

export default __exports__